import { useState } from 'react';
import { format } from 'date-fns';

/**
 * Custom hook to manage date filter state and logic
 */
const useDateFilters = (initialFilter = 'today') => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [activeFilter, setActiveFilter] = useState(initialFilter);
  
  // Set date to today
  const setDateToday = () => {
    const today = new Date();
    setStartDate(today);
    setEndDate(today);
    setActiveFilter("today");
    return { startDate: today, endDate: today };
  };

  // Set date to yesterday
  const setDateYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    setStartDate(yesterday);
    setEndDate(yesterday);
    setActiveFilter("yesterday");
    return { startDate: yesterday, endDate: yesterday };
  };

  // Set date range for last X days
  const setDateRange = (days) => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - (days - 1));
    setStartDate(start);
    setEndDate(end);
    setActiveFilter(`last${days}days`);
    return { startDate: start, endDate: end };
  };

  // Handle start date change
  const handleStartDateChange = (newValue) => {
    setStartDate(newValue);
    setActiveFilter("custom");
    return { startDate: newValue, endDate };
  };
  
  // Handle end date change
  const handleEndDateChange = (newValue) => {
    setEndDate(newValue);
    setActiveFilter("custom");
    return { startDate, endDate: newValue };
  };

  // Get formatted dates for API calls
  const getFormattedDateRange = () => {
    return {
      startDateFormatted: format(startDate, 'yyyy-MM-dd'),
      endDateFormatted: format(endDate, 'yyyy-MM-dd')
    };
  };
  
  return {
    startDate, 
    endDate,
    activeFilter,
    setDateToday,
    setDateYesterday,
    setDateRange,
    handleStartDateChange,
    handleEndDateChange,
    getFormattedDateRange
  };
};

export default useDateFilters; 